import { Component } from '@angular/core';

@Component({
  selector: 'app-products-landing',
  templateUrl: './products-landing.component.html',
  styleUrls: ['./products-landing.component.scss'],
  standalone: false
})
export class ProductsLandingComponent {
  productHighlights = [
    {
      title: 'ConnectIQ',
      subtitle: 'Cloud engine, analytics, rewards, and OTA stack',
      icon: 'bx-wifi',
      route: '/products/connectiq'
    },
    {
      title: 'Unified SDK',
      subtitle: 'Unified integration toolkit for connected mobility experiences',
      icon: 'bx-code-block',
      route: '/products/unifiedsdk'
    },
    {
      title: 'Hardware Devices',
      subtitle: 'OBD, TCU, DashCam, and Digital Cluster',
      icon: 'bx-chip',
      route: '/products/hardware'
    }
  ];

  connectIqProducts = [
    {
      title: 'SecureIQ',
      subtitle: 'PKI-driven trust, certificate lifecycle & zero-trust security',
      icon: 'bx-shield-quarter',
      route: '/products/connectiq/secureiq'
    },
    {
      title: 'Context Messaging',
      subtitle: 'Behavior-based customer communication flows',
      icon: 'bx-message-dots',
      route: '/products/connectiq/iq360'
    },
    {
      title: 'V-Store',
      subtitle: 'Marketplace for products, offers, and redemption',
      icon: 'bx-store',
      route: '/products/connectiq/vstore'
    },
    {
      title: 'Varroc Miles',
      subtitle: 'Loyalty engine tied to driving behavior and distance',
      icon: 'bx-gift',
      route: '/products/connectiq/miles'
    },
    {
      title: 'VC-SCORE',
      subtitle: 'Driving behavior transformed into actionable scores',
      icon: 'bx-line-chart',
      route: '/products/connectiq/vc-score'
    },
    {
      title: 'Oasis',
      subtitle: 'OEM dashboard for COTA and FOTA control',
      icon: 'bx-layout',
      route: '/products/connectiq/oasis'
    },
    {
      title: 'IIOT',
      subtitle: 'Connectivity that extends into industrial equipment',
      icon: 'bx-network-chart',
      route: '/products/connectiq/iiot'
    },
    {
      title: 'Vehicle App Store',
      subtitle: 'OEM-led in-vehicle app delivery and monetization',
      icon: 'bx-grid-alt',
      route: '/products/connectiq/vehicle-app-store'
    }
  ];

  sdkProducts = [
    {
      title: 'Unified SDK',
      subtitle: 'Single SDK foundation for mobile, web, cloud, and connected device integrations.',
      icon: 'bx-code-block',
      route: '/products/unifiedsdk'
    }
  ];

  hardwareProducts = [
    {
      title: 'OBD Dongle',
      subtitle: 'Plug-and-play vehicle data access and diagnostics',
      icon: 'bx-plug',
      route: '/products/hardware/obd'
    },
    {
      title: 'TCU',
      subtitle: 'Central telematics connectivity and communication unit',
      icon: 'bx-chip',
      route: '/products/hardware/tcu'
    },
    {
      title: 'Camzo Dashcam',
      subtitle: 'Video safety, monitoring, and evidence capture',
      icon: 'bx-camera',
      route: '/products/hardware/dashcam'
    },
    {
      title: 'Digital Cluster',
      subtitle: 'Rich in-vehicle display intelligence and interaction',
      icon: 'bx-devices',
      route: '/products/hardware/cluster'
    }
  ];
}
